import { store } from "../redux/store";
import {
  setSnackbar,
  SetSnackbarPayload,
  SnackbarSeverity,
} from "../redux/snackbarSlice";

const cancelNotify = (
  defaults: Partial<SetSnackbarPayload> = {},
  dispatch = store.dispatch
) => {
  return (
    message = defaults.message || "",
    payload: Partial<SetSnackbarPayload> = {}
  ) => {
    return dispatch(
      setSnackbar({
        severity: "error" as SnackbarSeverity,
        duration: 3000,
        ...defaults,
        ...payload,
        message,
      })
    );
  };
};

export default cancelNotify;
